
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.667 46.207c-1.372 0-5.985-2.427-10.432-8.038C11.478 33.429 7 25.257 7 13.244a2.83 2.83 0 012.454-2.637A77.413 77.413 0 0025.667 6a77.518 77.518 0 0016.215 4.606 2.831 2.831 0 012.454 2.638c0 12.013-4.479 20.185-8.236 24.925-4.447 5.611-9.061 8.038-10.433 8.038zM15.446 22.886a2.291 2.291 0 00-1.627.671 2.279 2.279 0 000 3.237l6.815 6.776a2.31 2.31 0 003.256 0l13.627-13.554a2.279 2.279 0 000-3.237 2.312 2.312 0 00-3.256 0l-12 11.935-5.188-5.158a2.3 2.3 0 00-1.627-.67z","fill":"#222"}})])
          )
        }
      }
    